export default "__VITE_ASSET__RTOvYeeX__"